/*eslint-disable no-useless-constructor */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Card, OverlayTrigger, Popover } from 'react-bootstrap';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { LinkContainer } from 'react-router-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import MasterPermissions from '../../api/MasterPermissions';
import sidebarMenu from '../../configuration/SidebarNav';
import MemberSummary from '../../api/MemberSummary';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { CLIENT_TYPES } from 'src/constants';
import { logout } from '../../../redux/app/userSlice';
import { useTranslation } from 'react-i18next';
import OutsideClickHandler from 'react-outside-click-handler';
import IdentityUserName from '../../img/Identity-username.png';
import { HelpIcon } from 'src/Member/img/sidenavbar/sidebarIcons';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import {
  NotificationBellSVG,
  ToolTipNotificationBellSVG,
  AffiliateAccountSVG,
} from 'src/Member/img/NotificationSVG';
import PortalName from '../header/PortalName';

export default function SideNavBar(props) {
  const { t } = useTranslation();
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const [sideMenuFlag, setSideMenuFlag] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });
  const [permissionOptionsMenu, setPermissionOptionsMenu] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutAction = () => {
    dispatch(logout({ preserveBearerToken: true }));
    //history.push( '/member/logout' );
    navigate('/member/logout');
    console.log('Logout -> isAuthenticated: ');
  };

  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;

  useEffect(() => {
    let permissionsMenu = [];
    const idToRemove = [];

    const spendingAccountFeature = FEATURES?.find(
      (feature) => feature.Name === 'spendingAccount',
    );
    if (spendingAccountFeature && spendingAccountFeature.Status === false) {
      idToRemove.push(4);
    }

    const feature = FEATURES?.find(
      (feature) => feature.Name === 'findProvider',
    );
    if (feature && feature.Status === false) {
      idToRemove.push(5);
    }

    const documentFeature = FEATURES?.find(
      (feature) => feature.Name === 'SendDocument',
    );
    if (documentFeature && documentFeature.Status === false) {
      idToRemove.push(7);
    }

    const estimateCostFeature = FEATURES?.find(
      (feature) => feature.Name === 'EstimateCostMember',
    );
    if (estimateCostFeature && estimateCostFeature.Status === false) {
      idToRemove.push(8);
    }

    if (idToRemove.length > 0) {
      permissionsMenu = sidebarMenu.filter(
        (item) => !idToRemove.includes(item.id),
      );
    } else {
      permissionsMenu = sidebarMenu;
    }
    console.log('Permission Menu Before: ', permissionsMenu);
    if (!MasterPermissions.CheckPermission('View Claims')) {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'Claims';
      });
    }
    if (MemberSummary.getSideMenuPermissions()) {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'Accounts';
      });
    }
    if (!MasterPermissions.CheckPermission('View Spending Account Details')) {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'Accounts';
      });
    }
    if (
      !MasterPermissions.CheckPermission('View Coverage Details') ||
      (!MasterPermissions.CheckPermission('Medical Coverage') &&
        !MasterPermissions.CheckPermission('Dental Coverage') &&
        !MasterPermissions.CheckPermission('Vision Coverage') &&
        !MasterPermissions.CheckPermission('Prescription Coverage') &&
        !MasterPermissions.CheckPermission('Long Term Disability Coverage') &&
        !MasterPermissions.CheckPermission('Short Term Disability Coverage') &&
        !MasterPermissions.CheckPermission('Supplemental Coverage'))
    ) {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'Coverages';
      });
    }
    if (userData?.UserType !== 'Employee') {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'Accounts';
      });
    }
    //if (!MasterPermissions.CheckPermission('Resource')) {
    //permissionsMenu = permissionsMenu.filter((permission) => {
    //return permission.text !== 'Resources';
    //});
    //}
    if (!MasterPermissions.CheckPermission('Access to Find Provider Tool')) {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'Find Provider';
      });
    }

    if (!MasterPermissions.CheckPermission('Access to Cost Estimator Tool')) {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'Estimate Cost';
      });
    }

    if (!MasterPermissions.CheckPermission('View Document')) {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'Document';
      });
    }
    if (!MasterPermissions.CheckPermission('View ID Cards')) {
      permissionsMenu = permissionsMenu.filter((permission) => {
        return permission.text !== 'ID Cards';
      });
    }
    console.log('Permission Menu After: ', permissionsMenu);

    setSideMenuFlag(true);
    setPermissionOptionsMenu(permissionsMenu);
  }, [MemberSummary.getSideMenuPermissions()]);

  const [showNotification, setShowNotification] = useState(false);
  const [getNotificationCount, setGetNotificationCount] = useState([]);

  //getNotificationcountapi
  const notificationCountList = async () => {
    try {
      const responseNotification = await axiosInstance.get(
        APIEndpoints.getNotificationcountapi(),
      );
      const MessageCounts =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageCount;
      setGetNotificationCount(MessageCounts);
    } catch (error) {
      return;
    }
  };

  const notificationShowHideHandler = () => {
    if (showNotification == false) {
      setShowNotification(true);
    } else {
      setShowNotification(!showNotification);
    }
  };

  useEffect(() => {
    notificationCountList();
  }, []);

  return (
    <div>
      <OutsideClickHandler
        onOutsideClick={(e) => {
          setExpanded(false);
        }}
      >
        {sideMenuFlag && (
          <SideNav
            onToggle={(expanded) => {
              setExpanded(expanded);
              setTimeout(() => {
                setShowNotification(expanded);
              }, 500);
            }}
            className="sideNavBar-member custom-scroller"
            expanded={expanded}
          >
            <SideNav.Toggle className="p-0" aria-label="menu list" />
            {(!isMobile || (isMobile && expanded)) && (
              <>
                {expanded && (
                  <PortalName
                    isSecure={true}
                    getNotificationCount={props.getNotificationCount}
                    setGetNotificationCount={props.setGetNotificationCount}
                    fromSideNav={true}
                  />
                )}

                {/*<div className="sidenavbar-header-icons">
                    <div className="d-flex flex-column header-sub-section">
                      {/* #TODO: make dynamic *
                      <p className="m-0 p-0 text-right main-heading">
                        Keenan TPA Benefit Access
                      </p>
                      {/* #TODO: make dynamic *
                      <p className="m-0 p-0 text-right sub-heading">
                        Member Portal
                      </p>
                    </div>*/}
                {/*<div className="">
                      <Link
                        to="/member/help-center"
                        className="help-icon sidenav-help-icon"
                        onClick={() => setExpanded(false)}
                      >
                        <HelpIcon
                          parentClass="parent-class"
                          childClass="child-class"
                        />
                      </Link>
                    </div>

                    <div>
                      {getNotificationCount?.Total > 0 ? (
                        <div className="demo">
                          <OverlayTrigger
                            show={showNotification}
                            placement="bottom-end"
                            delay={{ show: 1000, hide: 450 }}
                            overlay={
                              <Popover className="popover_notification-sidenav responsive-notification">
                                <Popover.Content>
                                  <Card className="my-notification-card responsive-notification">
                                    <div className="panel-card-header accordian-notification notification-tooltip d-flex align-items-center responsive-notification">
                                      <div className="notification-icon responsive-notification">
                                        <ToolTipNotificationBellSVG className="responsive-notification" />
                                      </div>
                                      <div className="notification-content responsive-notification">
                                        <span className="tooltip-header responsive-notification">
                                          You have {getNotificationCount?.Total}{' '}
                                          Notifications
                                        </span>
                                      </div>
                                    </div>
                                  </Card>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <div
                              className="notification-icon-container"
                              onClick={() => notificationShowHideHandler()}
                            >
                              <NotificationBellSVG
                                className="child-class"
                                parentClassName="notification-icon"
                              />
                              {getNotificationCount?.Total > 0 ? (
                                <span className="badge-class position-absolute"></span>
                              ) : (
                                ''
                              )}
                            </div>
                          </OverlayTrigger>
                        </div>
                      ) : (
                        <div className="notification-icon-container">
                          <NotificationBellSVG
                            className="child-class"
                            parentClassName="notification-icon"
                          />
                        </div>
                      )}
                    </div>
                  //</></div>*/}

                <SideNav.Nav>
                  {isLoggedIn && (
                    <NavItem
                      className="nav-link mobile-view d-md-none d-xs-block"
                      onClick={() => {
                        setExpanded(false);
                      }}
                    >
                      <NavIcon>
                        <img src={IdentityUserName} alt="User" />
                      </NavIcon>
                      <NavText className="user-icon">
                        <h4>{userData?.MemberDetails?.MemberName}</h4>
                        <p>
                          {t('member.sidenavbar.mem_id')}{' '}
                          <b>{userData?.MemberDetails?.CertificateNumber}</b>
                        </p>
                      </NavText>
                    </NavItem>
                  )}
                  <NavItem
                    className="nav-link mobile-view d-md-none d-xs-block affiliate-account-nav"
                    onClick={() => {
                      setExpanded(false);
                    }}
                  >
                    <NavIcon>
                      <Link to="/member/affiliate-account">
                        <AffiliateAccountSVG
                          className={'affiliate-account-plus-svg'}
                        />
                      </Link>
                    </NavIcon>
                    <NavText className="user-icon">
                      <Link to="/member/affiliate-account">
                        <span className="affiliate-account-title">
                          Affiliate Account
                        </span>
                      </Link>
                    </NavText>
                  </NavItem>
                  {permissionOptionsMenu.map((menuItem, index) => (
                    <LinkContainer
                      key={`${menuItem.id}${index}`}
                      to={menuItem.route}
                      state={
                        menuItem.text === 'Document'
                          ? {
                              comingFrom: 'DashboardUploadIcon',
                              state:
                                menuItem.text === 'Document' ? 'mymessage' : '',
                              notificationCount:
                                menuItem.text === 'Document'
                                  ? props.getNotificationCount
                                  : {},
                            }
                          : {
                              comingFrom: 'DashboardUploadIcon',
                            }
                      }
                    >
                      <NavItem
                        className="nav-link  working--@"
                        onClick={() => {
                          setExpanded(false);
                        }}
                      >
                        <NavIcon>
                          <Link
                            to={menuItem.route}
                            aria-label={`${menuItem.text}`}
                            state={
                              menuItem.text === 'Document'
                                ? {
                                    comingFrom: 'DashboardUploadIcon',
                                    state:
                                      menuItem.text === 'Document'
                                        ? 'mymessage'
                                        : '',
                                    notificationCount:
                                      menuItem.text === 'Document'
                                        ? props.getNotificationCount
                                        : {},
                                  }
                                : {
                                    comingFrom: 'DashboardUploadIcon',
                                  }
                            }
                          >
                            {menuItem.menuImg1}
                          </Link>
                        </NavIcon>
                        <NavText>{menuItem.text}</NavText>
                      </NavItem>
                    </LinkContainer>
                  ))}
                  <LinkContainer key="8" to="/member/my-profile">
                    <NavItem
                      className="nav-link mobile-view submenu d-md-none d-xs-block border-top"
                      onClick={() => {
                        setExpanded(false);
                      }}
                    >
                      <NavText>{t('member.sidenavbar.my_profile')}</NavText>
                    </NavItem>
                  </LinkContainer>
                  {/*<LinkContainer key="9" onClick={logoutAction}>
                <NavItem className="nav-link mobile-view submenu d-md-none d-xs-block">
                  <NavText>{t( 'member.sidenavbar.logout' )}</NavText>
                </NavItem>
              </LinkContainer> */}
                </SideNav.Nav>
              </>
            )}
          </SideNav>
        )}
      </OutsideClickHandler>
    </div>
  );
}
